import { useMemo } from 'react'

import { useModals } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { PageContextPayload } from '@contexts/pageContext'
import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

const List = (props: {pageFilters: any}) => {
  const { pageFilters } = props

  const modalContext = useModals()

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      sendPublicationInspectionsAlert: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
